<template>
  <div>
    <TemplatesTable></TemplatesTable>
  </div>
</template>

<script>
import TemplatesTable from 'CORE/components/project/template/create-form'

export default {
    name: 'TemplatesCreateFromView',
    components: {
        TemplatesTable,
    },
}
</script>
